import React from 'react';
import LandingPage from '../components/LandingPage';
import usePageMeta from '../hooks/usePageMeta';
import useHotjar from '../hooks/useHotjar';

function Home() {
  usePageMeta({
    title: 'Risqly Cybersecurity',
    description: 'See how external integrity and inherited risk are reflected in your Total Security Score.',
  });
  useHotjar();

  return <LandingPage />;
}

export default Home;
